import { render, staticRenderFns } from "./HorizontalMenu.vue?vue&type=template&id=459b4d50&scoped=true&"
import script from "./HorizontalMenu.vue?vue&type=script&lang=js&"
export * from "./HorizontalMenu.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalMenu.vue?vue&type=style&index=0&id=459b4d50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459b4d50",
  null
  
)

export default component.exports